const ITEMS = ["Pristine Spaces", "Restored Comfort", "Refreshed Living", "Gold Coast's Trusted Cleaners"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-brand py-5 overflow-hidden select-none"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-2xl sm:text-3xl text-white/95 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-white/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
